import React from 'react';
import CampTemplate from '../camp-template';
import LearnToCodeImage from 'assets/img/learn-to-code-img.jpg';
import styles from './styles.module.scss';

const JOSH_LEARNING_CENTER_ID = 6;

const LearnToCode = () => (
  <CampTemplate
    learningCenterId={JOSH_LEARNING_CENTER_ID}
    planId={7}
    headerTitle="Learn to Code from a Pro Programmer"
    headerSubtext="Join me in exploring how our digital world is put together and functions, all in a hands on environment using real-world examples like your favorite websites, and hands-on coding."
    headerImage={LearnToCodeImage}
    whenContent={
      <React.Fragment>
        <strong>July 7th - July 28th.</strong>
        <p>
          Tuesday, Wednesday, Thursday each week from 1:30PM - 3:00PM (90
          minutes/day).
        </p>
        <p>LIMIT to 12 learners per session.</p>
      </React.Fragment>
    }
    whoContent={
      <p className={styles.valueProp}>
        Learners 4th grade and above who are interested in technology and
        learning how to program. GREAT FOR FRIENDS TO DO TOGETHER!
      </p>
    }
    whatContent={
      <React.Fragment>
        <p className={styles.valueProp}>
          18 hours of engaging live instruction from a professional computer
          programmer who builds apps every day. The focus will be on how your
          child's favorite websites, games, and technology work, all while
          learning key basics of programming. An additional 12 hours of hands-on
          app building content and activities for optimal engagement!
        </p>
        <p>
          This fully remote/online program uses a private Zoom conference room
          and the Unyted.co online platform so learners participate in online
          breakout rooms as small teams. In addition, your child will do hands
          on coding and create a basic version of their first website. More than
          just hanging out in a zoom room, your child will actively
          problem-solve with peers and do hands-on activities like writing their
          own code and participating in escape rooms.
        </p>
        <p>
          <strong>Price:</strong>&nbsp;$325 per learner
        </p>
      </React.Fragment>
    }
  />
);

export default LearnToCode;
